<template>
  <button
    class="global-btn-primary mt-3"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script setup>
defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.global-btn-primary {
  background-color: #5201FF;
  color: white;
  padding: 0.5rem 1.25rem; 
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.2s ease;
  width: 97%;
}

.global-btn-primary:hover {
  background-color: #3e00cc; 
}

.global-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
